import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	label: string;
	amount: number;
};

export const RemainingRow: FC<Props> = ({ label, amount }) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			gap={1}
			sx={{
				px: 2,
				py: 1.5,
				bgcolor: theme.palette.grey[50],
				borderTop: `1px solid ${theme.palette.grey[100]}`,
			}}
		>
			<Typography variant="bodyMedium" color={theme.palette.grey[700]}>
				{label}
			</Typography>
			<Typography variant="bodyStrong" tabular>
				{amount.toLocaleString("cs-CZ")}{" "}
				{t(Resources.Goals.Amount.currencySign)}
			</Typography>
		</Stack>
	);
};
